/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartTrendXyUpIcon16Solid = forwardRef('DataChartTrendXyUpIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 2a1 1 0 0 0-2 0v10.5A2.5 2.5 0 0 0 2.5 15h12a1 1 0 1 0 0-2h-12a.5.5 0 0 1-.5-.5V2Z" }),
        React.createElement("path", { d: "M14.707 4.707a1 1 0 0 0-1.414-1.414L9.5 7.086 7.92 5.505a1.3 1.3 0 0 0-1.84 0L3.294 8.293a1 1 0 0 0 1.414 1.414L7 7.414l1.58 1.581a1.3 1.3 0 0 0 1.84 0l4.287-4.288Z" })));
});
